<template>
  <div>
    <!-- <main style="max-height: 100%;"> -->
    <main style="max-height: calc(100svh - 140px); overflow-y:auto;">
      <div class="WorkM_MainArea">
        <b-container fluid style="max-width: 700px">
          <div class="WorkM_ManagerAporoval">
            <b-tabs 
            fill
            class="mt-3"
            active-nav-item-class="font-weight-bold"
            pills
            justified
            >
              <!-- 申請承認 -->
              <b-tab @click="getApprovalApplicationInfo()" :title="applicationCount != null ? '事前申請(' + applicationCount + ')' : '事前申請(0)'" title-link-class="border border-primary mr-2" :active="isActive">
                <ApprovalApplication ref="ApprovalApplication" @getApprovalCount="getApprovalCount()"></ApprovalApplication>
              </b-tab>
              <!-- 報告承認 -->
              <b-tab @click="getApprovalWorkInfo()" :title="workCount != null ? '報告(' + workCount + ')' : '報告(0)'" title-link-class="border border-primary" :active="!isActive">
                <ApprovalWork ref="ApprovalWork" @getApprovalCount="getApprovalCount()"></ApprovalWork>
              </b-tab>
            </b-tabs>
          </div>
        </b-container>
      </div>
    </main>
  </div>
</template>

<script>
import config from "../../const/config";
import ApprovalApplication from "../../components/Parts/ApprovalApplication";
import ApprovalWork from "../../components/Parts/ApprovalWork";
export default {
  name: "Manager_Approval",
  components: {ApprovalApplication, ApprovalWork},
  data() {
    return {
      systemVersion: null,
      isActive: true,
      applicationCount: 0,
      workCount: 0,
    };
  },
  computed: {},
  watch: {},
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.loginUserId = this.$store.state.user_id;
    this.openFirstScreen();
  },

  methods: {
    getApprovalApplicationInfo: async function(){
      this.$refs.ApprovalApplication.getApprovalApplicationInfo();
      this.getApprovalCount();
    },
    getApprovalWorkInfo: async function(){
      this.$refs.ApprovalWork.getApprovalWorkInfo();
      this.getApprovalCount();
    },
    openFirstScreen: async function(){
      let type = this.$route.query.type;
      switch(type){
        case config.VALUE.DISPLAY_APPROVAL_TYPE_APPLICATION:
          this.isActive = true;
          this.getApprovalApplicationInfo();
          break;
        case config.VALUE.DISPLAY_APPROVAL_TYPE_WORK:
          this.isActive = false;
          this.getApprovalWorkInfo();
          break;
        default:
        this.afterApproval();
          break;
      }
    },
    afterApproval: async function(){
      console.log("call afterApproval");
      await this.getApprovalCount().then(()=>{
        this.changeScreen();
      })
    },
    changeScreen: function(){
      console.log("applicationCount: " + this.applicationCount);
      console.log("workCount: " + this.workCount);
      if (this.applicationCount > 0) {
        this.$refs.ApprovalApplication.getApprovalApplicationInfo();
        this.isActive = true;
      } else if (this.workCount > 0) {
        this.$refs.ApprovalWork.getApprovalWorkInfo();
        this.isActive = false;
      } else {
        this.$refs.ApprovalApplication.getApprovalApplicationInfo();
        this.isActive = true;
      }
    },
    // 承認すべき事前申請・勤務の件数を取得する
    getApprovalCount: async function(){
      let paramList = {
          shainCd: this.loginUserId,
          applicationKbn: config.VALUE.DISPLAY_APPROVAL_SCREEN_TYPE_APPROVAL,
      }
      await this.getWithParams(config.URL.APPROVAL_REGIST_COUNT, paramList)
        .then((response) => {
          // レスポンスの結果がfalseならエラーメッセージを表示
          this.applicationCount = response.container.applicationCount == null ? 0 : response.container.applicationCount;
          this.workCount = response.container.workCount == null ? 0 : response.container.workCount;
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    }
  },
};
</script>
<style>
.WorkM_ManagerAporoval {
  padding: 0 1rem;
}

.ApprovalSelectArea {
  margin-top: 0.5rem;
}
.WorkM_ManagerAporoval .ApprovalFooter{
  margin-left: -15px;
  margin-bottom: 0 !important; 
  background-color: #ececec !important;
  min-width: 700px!important; 
  right:auto; 
  left:auto;
}
</style>
